angular.module('ikeweb.user').service('creditCardService', ['promiseFactory',
        function(promiseFactory) {

            var CARD_NUMBER_DELIMITERS = /\s+|-/g;
            var CardNumberType = {
                'Diners Club': {
                    pattern: 'xxxx xxxx xxxx xx',
                    match: /^\d{14}$/
                },
                'American Express': {
                    pattern: 'xxxx xxxxxx xxxxx',
                    match: /^\d{15}$/
                },
                DEFAULT: {
                    pattern: 'xxxx xxxx xxxx xxxx',
                    match: /^\d{16}$/
                }
            };

            function loadCard(card) {
                var deferred = promiseFactory.deferredValue();
                Stripe.card.createToken({
                    name: card.cardHolderName,
                    number: card.cardNumber,
                    cvc: card.cvv,
                    /*eslint-disable camelcase */
                    exp_month: card.expiryMonth,
                    exp_year: card.expiryYear,
                    address_zip: card.zip
                    /*eslint-enable camelcase */
                }, function(errorCode, response) {
                    if (response.error) {
                        deferred.reject(response.error);
                        return;
                    }
                    deferred.resolve(response.id);
                });
                return deferred.promise;
            }

            function getCardNumberType(cardNumber) {
                var cardType = Stripe.card.cardType(cardNumber || '');
                return CardNumberType[cardType] || CardNumberType.DEFAULT;
            }

            function isValidCardNumber(cardNumber) {
                if (cardNumber == null) {
                    return false;
                }

                var numbers = cardNumber.replace(CARD_NUMBER_DELIMITERS, '');
                var match = getCardNumberType(cardNumber).match;
                return match.test(numbers);
            }

            function getCardNumberPattern(cardNumber) {
                return getCardNumberType(cardNumber).pattern;
            }

            return {
                loadCard: loadCard,
                isValidCardNumber: isValidCardNumber,
                getCardNumberPattern: getCardNumberPattern
            };
        }
    ])
    .config(['$provide', function($provide) {

        var functionsToDecorate = [
            'loadCard'
        ];

        $provide.decorator('creditCardService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService
                    .decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('creditCardService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
            function($delegate, decoratedPromiseBuilder, notificationService) {

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('loadCard')
                    .onError(notificationService.error('NOTIFICATION.BILLING.CARD.TITLE', 'NOTIFICATION.BILLING.CARD.LOAD.ERROR'))
                    .fork();
            }
        ]);
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit.card.service.js
// module id = 492
// module chunks = 0